module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ["sidebar", ("sidebar--" + _vm.currentRouteName)]
  }, [_c('div', {
    staticClass: "group group--df-column"
  }, [(_vm.showSidebarNav) ? _c('ul', {
    staticClass: "sidebar__nav fs0"
  }, _vm._l((_vm.navItems), function(item, index) {
    return _c('li', {
      key: index,
      class: [
        "sidebar__nav--item",
        _vm.activeSection === item.section ? "fw-bold sidebar__nav--item-active" : "" ],
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      on: {
        "click": function($event) {
          return _vm.scrollToSection(item.section)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.label) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showSidebarProvider) ? _c('div', {
    staticClass: "sidebar__provider-info fs0"
  }, [_c('div', {
    staticClass: "provider__avatar",
    style: (_vm.avatarBg)
  }), _vm._v(" "), (_vm.provider) ? _c('div', {
    class: ["provider", ("provider--" + (_vm.$route.name))]
  }, [(_vm.provider.topMatch) ? _c('span', {
    staticClass: "provider__pill",
    style: ({
      'background-color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Top match")]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "h2 provider__title",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.provider.fullname || _vm.provider.full_name))]), _vm._v(" "), _c('span', {
    staticClass: "provider__description fw-bold c-mid"
  }, [_vm._v(_vm._s(_vm.provider.specialty || _vm.provider.provider_type))]), _vm._v(" "), _c('span', {
    staticClass: "provider__description--mobile c-mid",
    domProps: {
      "innerHTML": _vm._s(_vm.mobileDescription)
    }
  }), _vm._v(" "), (_vm.providerDetails && _vm.providerDetails.patient_appointment_types && _vm.$route.name === "provider-schedule") ? _c('span', {
    staticClass: "provider__availability"
  }, [_vm._v("\n\n          Available by\n          "), (_vm.hasAvailability("video")) ? _c('span', {
    staticClass: "icon icon--video"
  }) : _vm._e(), _vm._v(" "), (_vm.hasAvailability("phone")) ? _c('span', {
    staticClass: "icon icon--phone"
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showSelectedSlot) ? _c('div', {
    staticClass: "selected-slot fs0"
  }, [_c('span', {
    staticClass: "selected-slot__icon selected-slot__icon--appointment"
  }), _vm._v(" "), _c('span', {
    staticClass: "selected-slot__label"
  }, [_vm._v(_vm._s(_vm._f("appointmentDateTime")(_vm.selectedSlot.timeslot)))])]) : _vm._e(), _vm._v(" "), (_vm.showSelectedSlot) ? _c('div', {
    staticClass: "selected-appointment fs0"
  }, [_c('span', {
    class: ["selected-appointment__icon", ("selected-appointment__icon--" + _vm.selectedAppointmentType)]
  }), _vm._v(" "), _c('span', {
    staticClass: "selected-appointment__label"
  }, [_vm._v(_vm._s(_vm.selectedAppointmentType))])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showRegistrationSuccess) ? _c('div', {
    staticClass: "sidebar__register-success"
  }) : _vm._e(), _vm._v(" "), (_vm.showDisclaimer) ? _c('module-disclaimer', {
    staticClass: "disclaimer--sidebar fs0"
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28359755"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Sidebar.vue
// module id = 471
// module chunks = 0